var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',_vm._b({attrs:{"type":_vm.type}},'v-skeleton-loader',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }